import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitDown1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-split-down, rules, direction, split"} maskId="square-filled-radius-0-stroke-1-IconArrowSplitDown1"><path d="M12.5 3V11.793L20 19.293V14H21V21H14V20H19.293L12 12.707L4.70703 20H10V21H3V14H4V19.293L11.5 11.793V3H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowSplitDown1;
